import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/projects/projectsApi";
import {
  useEditTaskMutation,
  useGetTaskQuery,
} from "../../features/tasks/tasksApi";
import { useGetTeamQuery } from "../../features/team/teamApi";

export default function Form() {
  const { data: team } = useGetTeamQuery();
  const { data: projects } = useGetProjectsQuery();
  const { taskId } = useParams();
  const { data: task, isSuccess } = useGetTaskQuery(taskId, {
    refetchOnMountOrArgChange: true,
  });
  const [editTask, { isSuccess: isEditSuccess }] = useEditTaskMutation();
  const nameRef = useRef();
  const teamRef = useRef();
  const projectNameRef = useRef();
  const deadlineRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      const { taskName, teamMember, project, deadline } = task;
      nameRef.current.value = taskName;
      teamRef.current.value = teamMember.name;
      projectNameRef.current.value = project.projectName;
      deadlineRef.current.value = deadline;
    }
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    const teamMember = team?.find((t) => t.name === teamRef.current.value);
    const project = projects?.find(
      (p) => p.projectName === projectNameRef.current.value
    );
    const data = {
      taskName: nameRef.current.value,
      teamMember,
      project,
      deadline: deadlineRef.current.value,
    };
    editTask({ id: taskId, data });
    navigate("/");
  };

  return (
    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="fieldContainer">
          <label htmlFor="lws-taskName">Task Name</label>
          <input
            ref={nameRef}
            type="text"
            name="taskName"
            id="lws-taskName"
            required
            placeholder="Implement RTK Query"
          />
        </div>

        <div className="fieldContainer">
          <label>Assign To</label>
          <select
            ref={teamRef}
            name="teamMember"
            defaultValue=""
            id="lws-teamMember"
            required
          >
            <option value="" hidden>
              Select Job
            </option>
            {team?.map((t) => (
              <option key={t.id}>{t.name}</option>
            ))}
          </select>
        </div>
        <div className="fieldContainer">
          <label htmlFor="lws-projectName">Project Name</label>
          <select
            ref={projectNameRef}
            id="lws-projectName"
            defaultValue=""
            name="projectName"
            required
          >
            <option value="" hidden>
              Select Project
            </option>
            {projects?.map((p) => (
              <option key={p.id}>{p.projectName}</option>
            ))}
          </select>
        </div>

        <div className="fieldContainer">
          <label htmlFor="lws-deadline">Deadline</label>
          <input
            ref={deadlineRef}
            type="date"
            name="deadline"
            id="lws-deadline"
            required
          />
        </div>

        <div className="text-right">
          <button type="submit" className="lws-submit">
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
